export default class AlMediaManagerDirectoryTreeController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.newSubDirectoryName = '';
        this.moveToDirectory = '';
        this.parentDirectory = null;
        this.allDirectories = [];

        this.currentLevel = 1;
        this.refresh = () => {};

        this.contextMenuOpenFor = false;

        this._initWatchers();
    }

    directoryClicked(directory, fresh = false) {
        this.newSubDirectoryName = '';

        if (this.onDirectoryClick) {
            this.onDirectoryClick({
                clickedDirectory: directory,
                fresh,
            }, fresh);
        }
    }

    passDirectoryClickedToTop(clickedDirectory) {
        this.directoryClicked(clickedDirectory);
    }

    createSubDirectory(parentDirectory, form) {
        if (!form.$valid) {
            return;
        }

        this.api.post(`media/directories${(parentDirectory.uuid) ? `/${parentDirectory.uuid}` : ''}`, {
            name: this.newSubDirectoryName
        }).then(({data}) => {
            this.alert.success(
                this.translate.instant('media.components.media-manager.sub-components.directory-tree.alerts.directory-created.title'),
                this.translate.instant('media.components.media-manager.sub-components.directory-tree.alerts.directory-created.content')
            )

            this.directoryClicked(data.data);
        }).catch((e) => {
            this.alert.handle(e);
        });
    }

    moveFile(file) {
        this.updateFile(file, {moveTo: this.moveToDirectory});
    }

    updateFile(file, data) {
        this.api.put(`media/files/${file.uuid}`, data)
            .then(() => {
                // this.alert.info(
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.title'),
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.content')
                // );
                this.refresh();
            })
            .catch((e) => {
                // this.alert.error(
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.title'),
                //     this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.content')
                // );
            })
    }

    delete(file) {
        this.alert.animatedAlert(
            this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.title'),
            this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.content'),
            'attention',
            {
                confirmButtonText: this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.confirm'),
                cancelButtonText: this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.ask-for-delete-file.cancel')
            }
        ).then(() => {
            this.api.delete(`media/files/${file.uuid}`)
                .then(() => {
                    this.alert.info(
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.title'),
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-success.content')
                    );

                    this.refresh();
                    this.directoryClicked(this.parentDirectory, true);
                })
                .catch((e) => {
                    this.alert.error(
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.title'),
                        this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.content')
                    );
                })
        });
    }

    loadDirectories(currentDirectory) {
        this.api.get(`media/directories/as-tree`)
            .then(({data}) => {
                this.allDirectories = data.data.filter((directory) => directory.uuid !== currentDirectory.uuid)
            })
            .catch((e) => {
                this.alert.error(
                    this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.title'),
                    this.translate.instant('media.components.media-manager.sub-components.directory-content-listing.alerts.delete-error.content')
                );
            })
    }

    // Private functions
    _initWatchers() {
        this.scope.$watch(() => {
            return this.depthLevel;
        }, () => {
            this.currentLevel = _.clone(this.depthLevel);
        })
    }
}

AlMediaManagerDirectoryTreeController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/sub-components/directory-tree/controller.js